import { getValueFromObject, toQueryString } from './common';
import { SortOption } from '../../graphql/types';

interface GenerateSortingHrefAndAsParams {
  search: string[] | string | undefined;
  queryObj: { [key: string]: string | undefined | string[] };
  sortValue: string;
  sortData?: SortOption[];
  pathname: string;
}

export const generateSortingHrefAndAs = ({
  search = [],
  queryObj,
  sortValue,
  sortData,
  pathname
}: GenerateSortingHrefAndAsParams) => {
  if (!sortData) {
    return { href: '', as: '' };
  }

  const { url, ...newQueryObj } = queryObj;
  const generateQueryString = (concatSign = '?') => {
    const updatedQueryObj = {
      ...newQueryObj,
      sorting: getValueFromObject(sortData, sortValue, 'params')
    };

    return Object.keys(updatedQueryObj).length
      ? `${concatSign}${toQueryString(updatedQueryObj)}`
      : '';
  };
  const searchArr =
    Array.isArray(search) && !search.includes('/pasha') ? search : [];

  const resolvedBasePath = search?.length
    ? searchArr.join('/')
    : pathname.replace('/', '');

  const cleanPath = (path: string) =>
    path.replace(/\/\//g, '/').replace(/([&?])$/, '');

  const href = cleanPath(
    `/${pathname}?url=${resolvedBasePath}${generateQueryString('&')}`
  );
  const slug =
    pathname.includes('pasha') && !resolvedBasePath.includes('pasha')
      ? '/pasha'
      : '';
  const as = cleanPath(`${slug}/${resolvedBasePath}${generateQueryString()}`);

  return { href, as };
};
